import React from "react";
import { useHistory } from "react-router-dom";
import {
  Flex,
  Heading,
  Stack,
  Button,
  useColorModeValue,
} from "@chakra-ui/react";

/**
 * Shown after a new user completes registration (e.g. via CAS).
 * Prompts them with "Welcome to Pinpoint!" and a Continue button to the Profile page.
 */
function WelcomeNewUser() {
  const history = useHistory();

  return (
    <Flex
      minH={"100vh"}
      align={"center"}
      justify={"center"}
      bg={useColorModeValue("gray.50", "gray.800")}
    >
      <Stack spacing={8} mx={"auto"} maxW={"lg"} py={12} px={6} align={"center"}>
        <Heading fontSize={"4xl"} textAlign={"center"}>
          Welcome to Pinpoint!
        </Heading>
        <Button
          size="lg"
          w="full"
          mt={8}
          onClick={() => history.push("/profile")}
        >
          Continue
        </Button>
      </Stack>
    </Flex>
  );
}

export default WelcomeNewUser;
